<template>
  <div class="container">
    <template v-if="module == 0">
      <div class="header">年度工作报告</div>
      <ul class="list-box">
        <li class="list-item" @click="openPDF('北京市昌平区明道健康研究院年度工作报告(2022-2023)')">
          <img src="~@/assets/images/pdf_icon.png" alt="" />
          <span class="list-item-label">北京市昌平区明道健康研究院年度工作报告</span>
          <span class="list-item-label">(2022-2023).pdf</span>
        </li>
        <li class="list-item" @click="openPDF('北京市昌平区明道健康研究院年度工作报告(2023-2024)')">
          <img src="~@/assets/images/pdf_icon.png" alt="" />
          <span class="list-item-label">北京市昌平区明道健康研究院年度工作报告(2023-2024).pdf</span>
          <span class="list-item-label">(2023-2024).pdf</span>
        </li>
      </ul>
    </template>
    <template v-if="module == 1">
      <div class="header">审计报告</div>
      <ul class="list-box">
        <li class="list-item" @click="openPDF('2022年明道研究院审计报告')">
          <img src="~@/assets/images/pdf_icon.png" alt="" />
          <span class="list-item-label">2022年明道研究院</span>
          <span class="list-item-label">审计报告.pdf</span>
        </li>
        <li class="list-item" @click="openPDF('2023年明道研究院审计报告')">
          <img src="~@/assets/images/pdf_icon.png" alt="" />
          <span class="list-item-label">2023年明道研究院</span>
          <span class="list-item-label">审计报告.pdf</span>
        </li>
      </ul>
    </template>
    <template v-if="module == 2">
      <div class="header">明道健康研究院捐赠披露</div>
      <div class="content">
        <table border cellpadding="0">
          <thead>
            <tr>
              <td>序号</td>
              <td>捐赠时间</td>
              <td>捐赠人</td>
              <td>金额（元）</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>2023年</td>
              <td>道博医疗科技（北京）有限公司</td>
              <td>475000</td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>

  </div>
</template>

<script>
export default {
  data() {
    return {
      module: 0,
      pdf: {
        财务管理制度: "/pdf/财务管理制度.pdf",
      },
    };
  },
  watch: {
    $route: {
      handler(val) {
        const { module } = val.params;

        this.module = module;
        console.log("val", val);
      },
      immediate: true,
    },
  },
  methods: {
    openPDF(name) {
      window.open(`/pdf/${name}.pdf`);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  flex: 1;
  margin: 0 160px 75px;
  background: url("~@/assets/images/main_bg.png") no-repeat left top / 100% #fff;
  border-radius: 8px;
  overflow: hidden;
}
.header {
  display: flex;
  justify-content: center;
  font-weight: 500;
  font-size: 30px;
  color: #3f3a3a;
  padding-top: 74px;
}
.content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 36px 74px;
  .line {
    text-indent: 30px;
    font-size: 20px;
    color: #3f3a3a;
    line-height: 63px;
  }
}
.list-box {
  display: flex;
  flex-wrap: wrap;
  padding: 42px 45px;
  .list-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 230px;
    height: 120px;
    margin-right: 24px;
    margin-bottom: 24px;
    background: #ffffff;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    cursor: pointer;
    &:nth-child(6n) {
      margin-right: 0;
    }
    img {
      width: 36px;
      height: 36px;
      margin-bottom: 17px;
    }
    .list-item-label {
      font-weight: 500;
      font-size: 16px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      text-align: center;
      width: 160px;
      color: #333;
    }
  }
}
table {
  border-collapse: collapse;
}
thead {
  background: #f1f1f1;
  border: 1px solid #dadada;
  td {
    height: 50px;
    text-align: center;
    color: #3f3a3a;
    font-size: 18px;
  }
}
tbody {
  background-color: #fff;
  border: 1px solid #dadada;
  td {
    height: 50px;
    text-align: center;
    color: #3f3a3a;
    font-size: 18px;
  }
}
</style>
